import { exceptionHandlerServiceModule } from '../../shared/app/services/exception-handler/exception-handler';
import { landingTrackerServiceModule } from './services/landing-tracker-service';
import { landingTrackClickComponentModule } from './components/track-click/track-click';
import { frameworkDemosComponentModule } from './components/framework-demos/framework-demos';
import { onScrollAddClassComponentModule } from './components/on-scroll-add-class/on-scroll-add-class';
import { previewVideoComponentModule } from './components/preview-video/preview-video';
import {
  salesLeadData,
  salesLeadFormComponentModule,
} from './components/sales-lead-form/sales-lead-form';
import { sectionAutoLinkComponentModule } from './components/section-auto-link/section-auto-link';
import { subscriptionsComponentModule } from './components/subscriptions/subscriptions';
import { configModule } from './config/config';
import { ngAnimateModule } from '../../shared/app/vendor/angular-modules';
import { articleCarouselComponentModule } from './components/article-carousel/article-carousel';
import { scrollToComponentModule } from '../../shared/app/components/scroll-to/scroll-to';
import { btnCtaDirectiveModule } from './components/btn-cta/btn-cta';
import { stickyHeaderComponentModule } from '../../shared/app/components/sticky-header/sticky-header';
import { cookieWarningServiceModule } from '../../shared/app/services/cookie-warning-service/cookie-warning-service';
import { featureCarouselDirectiveModule } from './components/feature-carousel/feature-carousel';
import { embeddedQualifiedTestComponentModule } from './components/embedded-qualified-test/embedded-qualified-test';
import { embeddedCalendlyComponentModule } from './components/embedded-calendly/embedded-calendly';
import { embeddedTypeFormComponentModule } from './components/embedded-type-form/embedded-type-form';

angular
  .module('Q.landing', [
    ngAnimateModule,

    exceptionHandlerServiceModule,

    configModule,

    landingTrackerServiceModule,
    landingTrackClickComponentModule,

    // app components
    frameworkDemosComponentModule,
    onScrollAddClassComponentModule,
    previewVideoComponentModule,
    salesLeadFormComponentModule,
    sectionAutoLinkComponentModule,
    subscriptionsComponentModule,
    articleCarouselComponentModule,
    scrollToComponentModule,
    btnCtaDirectiveModule,
    stickyHeaderComponentModule,
    cookieWarningServiceModule,
    featureCarouselDirectiveModule,
    embeddedQualifiedTestComponentModule,
    embeddedCalendlyComponentModule,
    embeddedTypeFormComponentModule,
  ])

  .controller('MainCtrl', function ($rootScope) {
    // make sales lead data available for other forms
    const sld = ($rootScope.salesLeadData = salesLeadData());
    if (sld.firstName || sld.lastName) {
      sld.name = `${sld.firstName} ${sld.lastName}`;
    }
  })

  .config(function ($locationProvider) {
    // Required to prevent $location from breaking anchor links (grrr)
    // One of the keys here is rewriteLinks: false - without it, $location prevents any standard
    // link from working as expected
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
      rewriteLinks: false,
    });
  });
